var map = {
	"./00-intro/00-intro.pug": 131,
	"./01-multitenancy/01-multitenancy.pug": 132,
	"./02-springboot/02-springboot.pug": 133,
	"./03-flyway/03-flyway.pug": 134,
	"./04-issues/04-issues.pug": 135,
	"./05-grails/05-grails.pug": 136
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;


//////////////////
// WEBPACK FOOTER
// ./src/slides \.md|markdown|\.pug$
// module id = 267
// module chunks = 1